import ClassInputAsync from 'components/ClassInputAsync'
import ListFilter from 'components/common/list-filter/ListFilter'
import CriterionInputAsyncInformed from 'components/CriterionInputAsyncInformed'
import DisciplineInputAsync from 'components/DisciplineInputAsync'
import InputSelectInformed from 'components/InputSelectInformed'
import { get } from 'lodash'
import React, { useCallback, useMemo } from 'react'

const CriterionListFilter = ({ onValueChange, ...props }: any) => {

    const booleanFilterValues = useMemo(() => ([
        { label: "Sim", value: true },
        { label: "Não", value: false }
    ]), [])

    const handleFilterChange = useCallback((data) => {
        const params = {
            discipline: get(data, 'discipline.value'),
            clss: get(data, 'clss.value'),
            criterion: get(data, 'criterion.value'),
            has_teacher: get(data, 'has_teacher.value'),
            is_release_window_set: get(data, 'is_release_window_set.value'),
            search: get(data, 'search')

        }
        onValueChange(params)
    }, [onValueChange])

    return (<ListFilter
        hasSearchInput
        onValueChange={handleFilterChange}
        searchInputLabel="Pesquisar um Currículo por Turma/Disciplina"
        searchInputPlaceholder="Pesquisar"
        {...props}
    >
        <DisciplineInputAsync
            openMenuOnClick={false}
            field="discipline"
            placeholder="Disciplina"
            label="Disciplina"
            params={{}}
        />
        <ClassInputAsync field="clss" placeholder="Turma" params={{}} />
        <CriterionInputAsyncInformed field="criterion" placeholder="Critério" params={{}} />
        <InputSelectInformed field="has_teacher" placeholder label="Possui professor" options={booleanFilterValues} />
        <InputSelectInformed field="is_release_window_set" label="Possui vigência de lançamento configurada" options={booleanFilterValues} />

    </ListFilter>
    )
}

export default CriterionListFilter
